module.exports = __webpack_public_path__ + "static/img/56.b4e0fb69.png";